<template>
  <div class="memberCenter_wrap OnlineBiddingNotice">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">在线竞价</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ ProjectName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title">广电计量采购平台</div>
    <div class="title1">网络竞价须知</div>
    <div class="content">
      <div class="text">
        <p>第一条 为规范广电计量采购平台（以下简称“交易平台”）交易行为，维护交易秩序，保护交易各方合法权益，根据国家法律、法规等有关规定，制定本须知。</p>
        <p>第二条 本须知适用于在交易平台上进行的公开竞价活动。</p>
        <p>第三条 本规则所称转让方，是指在交易平台注册并取得交易资格的企业。</p>
        <p>第四条 本规则所称竞买人，是指在交易平台注册取得交易资格，并取得竞买资格的企业。</p>
        <p>第五条 本须知所称买受人，是指第十条所定义的买受人。</p>
        <p>第六条 交易平台竞价遵循公开、公平、公正和诚实信用的原则。</p>
        <p>
          第七条 竞买人在竞价前务必详细阅读交易平台所发布的所有信息，包括：网络竞价须知、业务制度、挂牌项目公告的详细情况、标的的详细情况和特殊说明、注意事项、受让条件，标的物的图片、品质鉴定报告等。
          在交易平台所发布的信息、数据及介绍仅作为参考，不作任何承诺和担保。竞买人应到标的物现场详细察看标的物的现状和瑕疵情况，对标的有明确的认识，若标的现状与项目公告内容有差异的，以标的现状为准，一经成交交易价格不作调整。
        </p>
        <p>第八条 竞买人之间恶意串通，给他人造成损害者，依法承担赔偿责任，并承担相应法律责任。</p>
        <p>第九条 竞买人应在竞价前充分了解竞买标的的出让条件， 税费承担方式以及转让方所提出货物交割的要求。</p>
        <p>第十条 所有报价均在交易平台竞价系统中即时显示，最高报价的结果以交易平台竞价系统纪录数据为准。竞价交易系统显示“竞价结束”时，本次竞价活动结束。</p>
        <p>第十一条 当出现以下几种情况时，竞价活动中止或终止：</p>
        <p>（一） 没有竞买人在竞价交易系统报价，竞价活动终止；</p>
        <p>（二）在竞价过程中出现不可抗力或其他因素，导致竞价活动无法正常进行的，竞价活动中止或终止；</p>
        <p>
          （三）竞价活动中止的，当导致竞价活动无法正常进行的因素消失后，竞价活动重新开始或在调整时间后继续进行。调整后的时间，交易平台将通过平台公告或电话、短信形式向竞买人进行告知。因竞买人原因导致告知未及时知晓，从而未能在有效期内参与竞价的，交易平台不承担任何责任。
        </p>
        <p>第十二条 竞价成交后， 转让方与买受人的后续手续按公告要求等规定办理。</p>
        <p>第十三条 竞买人有如下行为时，其竞价无效，原交纳的保证金自动转为违约金：</p>
        <p>（一）竞买人之间恶意串通，损害国家、集体或他人合法权益的；</p>
        <p>（二）以其他行为扰乱竞价秩序，使竞价活动无法进行的；</p>
        <p>（三）竞买人提供虚假证明资料，导致竞价结果无效的；</p>
        <p>（四）竞买人有效报价后，又声明撤销的；</p>
        <p>（五）竞买人被确定为买受人后，放弃受让的或未按约定支付成交价款的；</p>
        <p>（六）交易平台认定的其他破坏正常交易秩序的行为。</p>
        <p>第十四条 交易平台对转让方或竞买人违反法律、法规或相关规定及违约行为不承担任何责任</p>
        <p>（一）若出现下列任何情况，交易中心不承担任何经济责任和法律责任：</p>
        <p>1、对因不可抗力因素以及系统故障、设备故障、通讯故障、电力故障等突发事故所产生的不可预测或不可控制因素造成损失的。</p>
        <p>2、网络竞价活动的时间以竞价系统服务器时间为准。由于竞买人自身终端设备时间与网络竞价系统服务器时间不符而导致未按时参与报价的；</p>
        <p>3、竞买人因自身原因导致其注册账户信息泄露而造成的一切后果；</p>
        <p>4、竞买人因遗忘密码、自身终端设备出现故障或网络异常而不能正常竞价的；</p>
        <p>5、因不可抗力、软硬件故障、非法入侵、恶意攻击导致系统故障无法继续竞价的，或者转让方、工商、司法、海关等监管部门紧急要求网络竞价中止或终止等原因导致报价中断的。</p>
        <p>
          交易中心将视情况组织继续竞价或重新竞价，并通知各竞买人。继续竞价或重新竞价的方式如下：竞价记录可以恢复的，以中断时的最高有效报价为起始价继续报价；竞价记录无法恢复的，以挂牌价为起始价重新竞价。
        </p>
        <p>
          （二）交易中心郑重提醒竞买人：在取得交易平台“登录账号及密码”后，务必注意登陆账号和密码的安全。凡使用该账号登入平台后所进行的一切报价及
          所做出的一切行为，均被视为账号所属注册用户的自主有效行为，该注册用户应对行为后果承担全部经济与法律责任。
        </p>
        <p>第十七条 竞买人应认真阅读并正确理解网络竞价须知的全部条款及内容，竞买人一旦通过交易平台注册使用，即表示对本网络竞价须知的全部条款及内容予以全部确认，无任何异议</p>
        <p>第十五条 免责声明</p>
        <p>（一）若出现下列任何情况，交易中心不承担任何经济责任和法律责任：</p>
        <p>1、对因不可抗力因素以及系统故障、设备故障、通讯故障、电力故障等突发事故所产生的不可预测或不可控制因素造成损失的。</p>
        <p>2、网络竞价活动的时间以竞价系统服务器时间为准。由于竞买人自身终端设备时间与网络竞价系统服务器时间不符而导致未按时参与报价的；</p>
        <p>3、竞买人因自身原因导致其注册账户信息泄露而造成的一切后果；</p>
        <p>4、竞买人因遗忘密码、自身终端设备出现故障或网络异常而不能正常竞价的；</p>
        <p>5、因不可抗力、软硬件故障、非法入侵、恶意攻击导致系统故障无法继续竞价的，或者转让方、工商、司法、海关等监管部门紧急要求网络竞价中止或终止等原因导致报价中断的。</p>
        <p>
          交易中心将视情况组织继续竞价或重新竞价，并通知各竞买人。继续竞价或重新竞价的方式如下：竞价记录可以恢复的，以中断时的最高有效报价为起始价继续报价；竞价记录无法恢复的，以挂牌价为起始价重新竞价。
        </p>
        <p>
          （二）交易中心郑重提醒竞买人：在取得交易平台“登录账号及密码”后，务必注意登陆账号和密码的安全。凡使用该账号登入平台后所进行的一切报价及
          所做出的一切行为，均被视为账号所属注册用户的自主有效行为，该注册用户应对行为后果承担全部经济与法律责任。
        </p>
        <p>第十七条 竞买人应认真阅读并正确理解网络竞价须知的全部条款及内容，竞买人一旦通过交易平台注册使用，即表示对本网络竞价须知的全部条款及内容予以全部确认，无任何异议</p>
      </div>
      <div style="text-align: center" ref="agreenCheckWrap">
        <el-checkbox v-model="agreen" :disabled="isPermit" ref="agreenCheck">我已阅读《广电计量采购平台网络竞价须知》</el-checkbox>
        <span v-if="isPermit">请仔细阅读，{{ times }}秒后可勾选</span>
      </div>
    </div>
    <div class="btn_wrap">
      <span class="btn_1 btn_1_1" @click="back">不同意</span>
      <span class="btn_1" @click="submit">同意</span>
    </div>
  </div>
</template>

<script>
import Steps from '@/components/common/Steps'
export default {
  components: { Steps },
  data() {
    return {
      times: 30,
      isPermit: true,
      agreen: false,
      flag: true,
      ProjectName: this.$route.query.ProjectName,
      SchemeId: this.$route.query.SchemeId
    }
  },
  mounted() {
    window.addEventListener('scroll', this._scroll)
  },
  methods: {
    _scroll() {
      if (this.flag) {
        this.flag = false
        this.setCheckbox()
      }
    },
    setCheckbox() {
      var timer = setInterval(() => {
        this.times--
        if (this.times === 0) {
          this.isPermit = false
          clearInterval(timer)
        }
      }, 1000)
    },
    submit() {
      if (this.agreen == false) {
        var cc = this.$message('请先勾选同意协议')
        setTimeout(() => {
          cc.close()
        }, 1000)
        return
      }
      let routerData = this.$router.resolve({
        name: 'OnlineBiddingRoom',
        query: {
          SchemeId: this.SchemeId,
          ProjectName: this.ProjectName
        }
      })
      window.open(routerData.href, '_blank')
      setTimeout(() => {
        window.close()
      }, 1000)
    },
    back() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.OnlineBiddingNotice {
  .btn_wrap {
    width: 500px;
    margin: 35px auto 50px;
    .btn_1 {
      font-weight: bold;
      margin: 0 30px;
    }
    .btn_1_1 {
      background: #fff;
    }
  }
  .title {
    height: 100px;
    line-height: 100px;
    color: #0774c5;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }
  .title1 {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }
  .boldred {
    color: #f80303;
    font-weight: bold;
  }
  .content {
    width: 68%;
    margin: 0 auto;
    .text {
      margin-bottom: 40px;
      line-height: 25px;

      div {
        font-weight: bold;
        margin: 20px 0;
      }
      .headline {
        font-weight: bold;
      }
      p {
        margin: 20px 0;
        text-indent: 2em;
      }
    }
  }
}
</style>
